module.exports = __webpack_public_path__ + "plugins/web/img/bg1.9a5f6e40.jpg";